import React from 'react';
import LoadHome from 'bundle-loader?lazy&name=home!./routes/home/home.jsx';
import LoadCardSearch from 'bundle-loader?lazy&name=card-search!./routes/card-search/card-search.jsx';
import LoadUploadCard from 'bundle-loader?lazy&name=card-upload!./routes/card-upload/card-upload.jsx';
import LoadUploadView from 'bundle-loader?lazy&name=card-view!./routes/card-view/card-view.jsx';
import LoadEditCard from 'bundle-loader?lazy&name=card-upload!./routes/card-edit/card-edit.jsx';

const Bundle =
  ( Component, routeProps = {} ) =>
  ( props ) =>
    <Component { ...props } { ...routeProps } />;
// App Routings
export const routes = [
  {
    title: 'Card Search',
    pattern: '/search/:companyId?',
    load: LoadCardSearch
  },
  {
    title: 'Card View',
    pattern: '/search/:cardId/:companyId?',
    load: LoadUploadView
  },
  {
    title: 'Upload Cards',
    pattern: '/upload/:companyId?',
    load: LoadUploadCard
  },
  {
    title: 'Edit Cards',
    pattern: '/edit/:id/:companyId?',
    load: LoadEditCard
  },
  {
    title: 'Home',
    pattern: '/home/:companyId?',
    load: LoadHome
  },
  {
    title: 'Home',
    pattern: '/:companyId?',
    load: LoadHome
  }
];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
  const { match } = nextRoute;
  if ( match && !match.render && typeof match.load === 'function' ) {
    match.load( ( asyncModule ) => {
      match.render = Bundle(
        asyncModule.default ? asyncModule.default : asyncModule,
        match.props
      );
      action.ok();
    } );
  } else {
    action.ok();
  }
}
